var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"LayoutDefault"}},[_c('div',{staticClass:"layout__content"},[_c('h1',{staticClass:"title"},[_vm._v("Lamb Weston / Meijer Customer Portal")])])])}
var staticRenderFns = []

export { render, staticRenderFns }